import React from "react";
import PlantelEquipoTorneo from "./PlantelEquipoTorneo.js";
import ListaPartidos from "./ListaPartidos.js";
import { Partidos as TipoLista } from "../../constantes/Filtros.js";

const DetalleEquipoTorneo = (props) => {
  const datosElegidos = props.datosElegidos;

  return (
    <React.Fragment>
      {datosElegidos && datosElegidos.torneo && datosElegidos.equipo && (
        <React.Fragment>
          <ListaPartidos
            tipoLista={TipoLista.EQUIPO}
            datosElegidos={datosElegidos}
          />
          <PlantelEquipoTorneo torneo={datosElegidos.torneo} equipo={datosElegidos.equipo} />
        </React.Fragment>
      )}
    </React.Fragment>
  );
};

export default DetalleEquipoTorneo;
